import React, { useEffect } from 'react';
import { SmsTask } from 'nekst-api';
import { useState } from 'react';
import useDataLoader from 'data-loader';
import { SmsTaskPreview, useSmsTaskPreviewService } from '../smsTaskPreviewService';
import { LoadingAnimation } from 'ui-builder';
import Layout from './Layout';


export function SendSmsPreview(
  props: {
    task: SmsTask,
    onPreviewsLoaded?: (previews: SmsTaskPreview[]) => void,
  }
) {

  const [smsTaskPreviews, setSmsTaskPreviews] = useState<SmsTaskPreview[]>();

  const smsTaskPreviewService = useSmsTaskPreviewService();

  useDataLoader(
    () => smsTaskPreviewService.getSmsTaskPreview(props.task.id),
    setSmsTaskPreviews,
  );

  useEffect(() => {
    if (smsTaskPreviews && props.onPreviewsLoaded) {
      props.onPreviewsLoaded(smsTaskPreviews);
    }
  }, [smsTaskPreviews, props.onPreviewsLoaded]);

  if (smsTaskPreviews) {
    return (
      <Layout previews={smsTaskPreviews} />
    );
  } else {
    return (<LoadingAnimation />);
  }
}
